import { updateCookie, REDUX_COOKIES_SET, REDUX_COOKIES_REMOVE, } from './actions';
export function createMiddleware() {
    const actionsMap = {
        [REDUX_COOKIES_SET]: (action) => {
            return updateCookie(action.payload.name, action.payload.value, action.payload.options);
        },
        [REDUX_COOKIES_REMOVE]: (action) => {
            return updateCookie(action.payload, undefined);
        },
    };
    return () => (next) => (action) => {
        if (action.type in actionsMap) {
            return next(actionsMap[action.type](action));
        }
        return next(action);
    };
}
//# sourceMappingURL=middleware.js.map